import { render, staticRenderFns } from "./step-add-cups-bill.vue?vue&type=template&id=20d5f8d0&scoped=true&"
import script from "./step-add-cups-bill.vue?vue&type=script&lang=js&"
export * from "./step-add-cups-bill.vue?vue&type=script&lang=js&"
import style0 from "./step-add-cups-bill.vue?vue&type=style&index=0&id=20d5f8d0&lang=scss&scoped=true&"
import style1 from "./step-add-cups-bill.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5f8d0",
  null
  
)

export default component.exports